import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { StripeElementsOptionsMode } from '@stripe/stripe-js';

export enum SimpleButtonTypes {
  applyCoupon = 'applyCoupon',
  remove = 'remove',
  removeSavedDeal = 'removeSavedDeal',
  removeFromCart = 'removeFromCart',
  addSavedDeal = 'addSavedDeal',
}
export enum SimpleButtonSizes {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

export const SIMPLE_BUTTON_TYPES = {
  applyCoupon: {
    text: 'Apply a coupon',
    icon: faPlus,
    color: 'text-bolt',
  },
  remove: {
    text: 'Remove coupon',
    icon: faTrash,
    color: 'text-brick',
  },
  removeSavedDeal: {
    text: 'Remove from saved',
    icon: faTrash,
    color: 'text-brick',
  },
  removeFromCart: {
    text: 'Remove',
    icon: faTrash,
    color: 'text-brick',
  },
  addSavedDeal: {
    text: 'Save for later',
    icon: faBookmark,
    color: 'text-bolt',
  },
};

export const DEFAULT_SWR_OPTIONS = {
  errorRetryCount: 2,
  dedupingInterval: 3000,
};

export const AFFILIATE_URL =
  'https://go.appsumo.com/become-appsumo-affiliate?ref=account_menu';

export const BUY_PLUS_URL = '/products/plus-2019/buy/';

export const STRIPE_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY ?? '';

export const STRIPE_OPTIONS_OBJECT = {
  mode: 'payment',
  currency: 'usd',
  amount: 50, // Minimum amount to make a purchase
  paymentMethodCreation: 'manual',
  // Fully customizable with appearance API.
  appearance: {
    /*...*/
  },
} as StripeElementsOptionsMode;

export const START_EMAIL_VERIFICATION_DATE = '2023-08-27';

export enum LAYOUT_TYPES {
  CART = 'cart',
  CHECKOUT_COMPLETE = 'checkoutComplete',
}
